// The chrome of the pages outside the workbench (projects, members,
// operator): organisation switch (GIOTHUB-186), language switch (GIOTHUB-185),
// help, the person and sign-out.
import type { ComponentChildren } from "preact";
import { t, useLang } from "../i18n";
import { signOut } from "../lib/auth";
import { setActiveOrg } from "../lib/org";
import type { Me } from "../lib/types";
import { Logo } from "../workbench/icons";
import { LangSwitch } from "./Login";

export function roleName(r: string): string {
  return r === "admin" ? t("role.admin") : r === "builder" ? t("role.builder") : r === "viewer" ? t("role.viewer") : r;
}

export function Shell({ me, active, children }: { me: Me | null; active: "projects" | "members" | "admin"; children: ComponentChildren }) {
  useLang();
  const tab = (href: string, id: typeof active, label: string) => (
    <a href={href} class={`btn btn-ghost ${active === id ? "bg-hover text-ink" : ""}`} aria-current={active === id ? "page" : undefined}>{label}</a>
  );
  return (
    <div class="flex h-full flex-col bg-bar text-ink">
      <header class="flex min-h-12 flex-none flex-wrap items-center gap-x-3 gap-y-1 border-b border-line px-3 py-1.5">
        <a href="/" class="flex items-center gap-2 no-underline"><Logo /><span class="text-[14px] font-semibold text-ink">gIoTHub</span><span class="text-muted">Type Builder</span></a>
        {me && me.organisation && (
          <nav class="ml-2 flex items-center gap-1">
            {tab("/", "projects", t("nav.projects"))}
            {tab("/members", "members", t("nav.members"))}
            {me.operator && tab("/admin", "admin", t("nav.organisations"))}
          </nav>
        )}
        <div class="flex-1" />
        {me && me.orgs.length > 1 && me.organisation ? (
          <label class="flex items-center gap-1.5 text-[12.5px] text-muted">
            <span class="sr-only">{t("nav.organisation")}</span>
            <select class="field !w-auto !py-1 text-[12.5px]" value={me.organisation.id}
              onChange={(e) => { setActiveOrg((e.target as HTMLSelectElement).value); location.href = "/"; }}>
              {me.orgs.filter((o) => o.build_enabled).map((o) => <option value={o.id}>{o.name || o.id}</option>)}
            </select>
            <span>· {roleName(me.role)}</span>
          </label>
        ) : me && me.organisation ? (
          <span class="text-[12.5px] text-muted">{me.organisation.name || me.organisation.id} · {roleName(me.role)}</span>
        ) : null}
        <a class="btn btn-ghost" href="/help">{t("common.help")}</a>
        <span class="text-muted"><LangSwitch /></span>
        {me && (
          <button type="button" class="btn btn-ghost" title={me.email} onClick={() => signOut()}>{t("nav.signout")}</button>
        )}
      </header>
      {children}
    </div>
  );
}
